import React, { useEffect, useState } from 'react';
import { COMPANY_INFO } from '../utils/constants';

const Header: React.FC = () => {
  const [collapsed, setCollapsed] = useState(false);

  useEffect(() => {
    const onScroll = () => {
      setCollapsed(window.scrollY > 48);
    };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <header
      className={`bg-white border-b border-primary-100 overflow-hidden transition-all duration-300 ease-out ${
        collapsed ? 'max-h-0 border-b-0 opacity-0' : 'max-h-28 opacity-100'
      }`}
    >
      <div className="container py-4 md:py-5">
        <div className="flex items-center justify-between flex-wrap gap-4">
          <div className="flex items-center min-w-0 flex-1">
            <div className="flex items-center space-x-3 md:space-x-4">
              <img
                src="/images/logo.jpg"
                alt={COMPANY_INFO.shortName}
                className="w-10 h-10 md:w-11 md:h-11 object-contain flex-shrink-0"
                width={44}
                height={44}
              />

              <div className="text-left min-w-0">
                <h1 className="font-display text-lg md:text-xl font-semibold text-primary-800 leading-tight tracking-tight">
                  <span className="hidden sm:inline">{COMPANY_INFO.name}</span>
                  <span className="sm:hidden">{COMPANY_INFO.shortName}</span>
                </h1>
                <p className="text-xs md:text-sm text-primary-400 mt-0.5 hidden sm:block tracking-wide">
                  专业消防整体解决方案服务商
                </p>
              </div>
            </div>
          </div>

          <div className="flex items-center">
            <a
              href="tel:18600385876"
              className="flex items-center text-sm md:text-base text-primary-700 hover:text-primary-600 transition-colors"
            >
              <i className="fas fa-phone text-primary-600 mr-2 text-sm"></i>
              <span className="tracking-wide">18600385876</span>
            </a>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
